export default __webpack_public_path__ + "static/media/archivedhighlight.a9654451.svg";